define([
    'language/resource',
    'authui/iamUtils',
    'base/utils/cookie',
    'base/utils/utility',
    'base/utils/iamHttpService',
    'base/utils/preVerifycodeUtilNew',
    'base/widgets/graphicVerifyWindow/window',
], function (i18n, iamUtils, cookieOp, utils, iamHttpService, perVerifycodeUtilNew, GrahicVerifyWindow) {
    'use strict';

    var _securityPolicy;
    function CustomerFPwdController($scope, securityPolicy, $compile, $interval, $state) {
        _securityPolicy = securityPolicy;
        $scope.i18n = i18n;
        $scope.ipIsInternational = iamUtils.ipIsInternational();
        document.title = i18n('titles.fpwd');
        try {
            var userType = getQueryString('UserType');
            iamUtils.initialCloudBI('/authui/public/custom/findPwd.html?UserType=' + userType + '#/fpwd', { C1: 'IAM-Login-' + userType + '-fpwd' });
        } catch (e) {
            console.dir(e)
        }
        $scope.model = {
            showConfig: iamUtils.getShowConfig(cookieOp),
            isMobile: window.outerWidth > 500 ? false : true,
            currentStep: 1,
            isCompany: iamUtils.getUrlParams()['UserType'] === 'e', //是否是IAM用户找回密码
            fpwdErrorMsg: '',
            findMethod: 'name', //主帐号找回密码的方式：name/phone
            inputWidth: 380,
            inputHeight: 40,
            // 步骤按钮
            submitBtnTxt: i18n('submitBtnTxt'),
            cancelBtnTxt: i18n('cancelBtnTxt'),
            stepLastBtnTxt: i18n('fpwd.backTo'),
            stepNextBtnTxt: i18n('fpwd.nextStepBtn'),
            doLoginBtnTxt: i18n('fpwd.goToLogin'),
            emailRegExp: /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
            // userexists接口返回的用户信息
            userId: '',
            domainId: '',
            isDomain: '',
            canNextStep: true,//是否可以进行下一步
            authToken: '',//validate接口返回的数据
            //帐号密码策略相关信息
            contSameCharLen: 0,
            maxSameChars: '',
            pwdMinLen: 6,
            name: '',
            containsChars: i18n('passwordChars'),
            validTip: require('custom/images/default.png'),
            validSuc: require('custom/images/right.png'),
            validFail: require('custom/images/wrong.png'),
            //主账号子账号找回密码切换
            typeChangeHandler: function () {
                resetPage($scope);  // 页面内容重置
                $scope.model.isCompany = !$scope.model.isCompany;
            },
            //帐号名或手机找回切换
            methodChangeHandler: function (method) {
                resetPage($scope);  // 页面内容重置
                $scope.model.findMethod = $scope.model.findMethod === 'phone' ? 'name' : 'phone';
            },
        };

        //主帐号找回密码 帐号名输入框
        $scope.personalAccountInput = {
            id: 'personalAccount',
            value: '',
            maxLength: 255,
            ph: $scope.model.isMobile ? i18n('fpwd.accountOrEmailPH.h5') : i18n('fpwd.accountOrEmailPH'),
            style: {
                height: $scope.model.inputHeight,
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'personalAccountBlur', $scope.personalAccountInput.value);
            },
            change: function () {
                $scope.model.fpwdErrorMsg = '';
            }

        }

        //主帐号找回密码 国家码选择及手机号输入框
        $scope.phoneInput = {
            countryCodeSelectId: 'countryCodeSelectId',
            countryCodeOptions: [],
            defaultOption: {},
            selectDisabled: true,
            selectStyle: {
                height: $scope.model.inputHeight,
                width: '129px',
            },
            selectChange: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_accountPhone_CountryCode', $scope.phoneInput.defaultOption.id);
            },
            phoneInputId: 'phoneInputId',
            phonePH: $scope.model.isMobile ? i18n('fpwd.step1.phoneAccountNamePH.h5') : i18n('fpwd.step1.phoneAccountNamePH') ,
            phoneValue: '',
            oldPhoneValue: '',
            focused: false,
            phoneInputStyle: {
                width: 250,
                height: $scope.model.inputHeight,
            },
            phoneMaxLength: 11,
            phoneBlur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'mobileBlur', $scope.phoneInput.phoneValue);
                // 手机号查找获取用户
                if (phoneValidator($scope)) {
                    mobileExist($scope);
                }
                $scope.phoneInput.phoneTipShow = false;
                $scope.phoneInput.focused = false;
            },
            phoneFocus: function () {
                $scope.phoneInput.phoneTipShow = true;
                $scope.phoneInput.focused = true;
            },
            phoneChange: function () {
                $scope.model.fpwdErrorMsg = '';
                $scope.IAMVerifyCode.checkCode = '';
                phoneValidator($scope);
            },
            phoneTipId: 'phoneTipId',
            phoneTipShow: false,
            phoneErrorContent: '',
        }

        // 手机号多用户下拉选择框
        $scope.mobileUsers = {
            id: 'mobileUsers',
            show: false,
            style: {
                width: '320px',
                height: $scope.model.inputHeight,
            },
            selectOptions: [],
            defaultOption: {},
            showOptions: false,
            focus: function () {
                $scope.mobileUsers.showOptions = true;
            },
            blur: function () {
                if (!$scope.model.isMobile) { $scope.mobileUsers.showOptions = false; }
            },
            click: function () {
                $scope.mobileUsers.showOptions = true;
            },
            maskClick: function ($event) {
                $scope.mobileUsers.showOptions = false;
                $event.stopPropagation();
            },
            select: function (option) {
                setTimeout(function () {
                    $scope.mobileUsers.defaultOption = option;
                    $scope.mobileUsers.showOptions = false;
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }, 10)
            }
        };

        // IAM 帐号名输入框
        $scope.IAMAccountInput = {
            id: 'IAMAccount',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.IAMAccountPH.h5') : i18n('fpwd.IAMAccountPH'),
            maxLength: 255,
            style: {
                height: 40,
            },
            change: function () {
                $scope.model.fpwdErrorMsg = '';
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'IAMAccountBlur', $scope.IAMAccountInput.value);
            }
        };

        // IAM 用户名输入框
        $scope.IAMUsernameInput = {
            id: 'IAMUser',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.IAMAccountNamePHNew.h5') : i18n('fpwd.IAMAccountNamePHNew'),
            style: {
                height: 40,
            },
            maxLength: 255,
            change: function () {
                $scope.model.fpwdErrorMsg = '';
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + 'IAMUserBlur', $scope.IAMUsernameInput.value);
                send2CloudBISafe('input', 'iamUserFpwd', '', 'operation_iam_iamUserFpwd_step1');
            }
        };

        // 图形验证码
        $scope.IAMVerifyCode = {
            checkCodeId: 'checkCodeId',
            checkCode: '',
            maxLength: 4,
            style: {
                height: $scope.model.inputHeight,
            },
            focused: false,
            checkCodePH: $scope.model.isMobile ? i18n('fpwd.verifyCodePlaceHolder.h5') : i18n('fpwd.verifyCodePlaceHolder'),
            checkCodeTip: i18n('getVerifyCode'),
            verifycode: '/authui/verifycode?index=4&alt=' + Math.random(),
            preValidVerifyCode: function () {
                var failResultId = 'verifyCodeVaildResult';
                var verifyCodeId = $scope.IAMVerifyCode.checkCodeId;
                perVerifycodeUtilNew.preValidVerifyCodeNew(failResultId, verifyCodeId, $scope.IAMVerifyCode.checkCode, '4', preValidCallback, iamHttpService);
            },
            preValidVerifyCodeBlur: function () {
                $scope.IAMVerifyCode.focused = false;
                send2CloudBISafe('input', 'change', 'login_company_personal_VerifyCode', $scope.IAMVerifyCode.checkCode);
            },
            focus: function () {
                $scope.IAMVerifyCode.focused = true;
            },
            getVerifyCode: function () {
                send2CloudBISafe('button', 'click', 'login_company_getVerifyCode', '');
                var verifyCodeImg = $('#inputVerifyCodeImg')[0];
                if (verifyCodeImg) {
                    verifyCodeImg.src = '/authui/verifycode?index=4&alt=' + Math.random();
                }
                $scope.IAMVerifyCode.checkCode = '';
                $('#validresultImg').hide();
            },
        };

        // 第二步 获取验证码
        $scope.authMethod = {
            hasPhone: false,
            phoneObj: {},
            hasEmail: false,
            emailObj: {},
            selectMethod: '',
            selectObj: {},
            authMethodChange: function () {
                $scope.authVerifyCode.value = '';
                if ($scope.authMethod.selectMethod === 'phone') {
                    $scope.authMethod.selectMethod = 'email';
                    $scope.authMethod.selectObj = $scope.authMethod.emailObj;
                } else {
                    $scope.authMethod.selectMethod = 'phone';
                    $scope.authMethod.selectObj = $scope.authMethod.phoneObj;
                }
            },
            retrieveVerifyCode: false,
            retrieveVerifyCodeTxt: '',
            sendVerifyCodeClick: function () {
                send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_getMsgCode', '');
                if ($scope.authMethod.retrieveVerifyCode) {
                    return;
                }
                $scope.authVerifyCode.value = '';

                iamHttpService.get({
                    url: '/rest/authui/verifycode/needverify',
                    params: {
                        scene: 'findpwd',
                        userid: $scope.model.userId,
                        domainid: $scope.model.domainId,
                        type: $scope.authMethod.selectMethod,
                        isdomain: $scope.model.isDomain
                    }
                }).then(function (data) {
                    var data = typeof data === 'object' ? data : $.parseJSON(data);
                    if (data.needVerify) {
                        $scope.graphicVerifyCodeModal.show(
                            (verifyCode) => {
                                retrieveCountdown($scope, $interval)
                                setTimeout(sendVerifyCode($scope, verifyCode), 200);
                            }
                        );
                    } else {
                        retrieveCountdown($scope, $interval);
                        setTimeout(function () {
                            sendVerifyCode($scope, null);
                        }, 200);
                    }
                }, function () {
                    $('#sendVerifyCode').removeClass('disabled');
                    iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'popupMsg');
                });
            }
        }
        // 手机邮箱验证码输入框
        $scope.authVerifyCode = {
            id: 'authVerifyCodeId',
            value: '',
            ph: i18n('loginVerification.verifyCodePH'),
            style: {
                height: 36,
            },
            maxLength: '6',
            errorContent: '',
            tipId: 'authVerifyCodeTipId',
            tipShow: false,
            focus: function () {
                $scope.authVerifyCode.tipShow = true;
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_msgCodeBlur', $scope.authVerifyCode.value);
                $scope.authVerifyCode.tipShow = false;
            },
            change: function () {
                $scope.authVerifyCode.verifycodeErrorInfo = '';
                $scope.authVerifyCode.validate();
            },
            validate: function () {
                if (!$scope.authVerifyCode.value || $scope.authVerifyCode.value.trim().length === 0) {
                    $scope.authVerifyCode.errorContent = i18n('emptyTxt');
                    return false;
                }
                var reg = /^[a-zA-Z0-9]*$/;
                if (!reg.test($scope.authVerifyCode.value)) {
                    $scope.authVerifyCode.errorContent = i18n('commonContainsChar');
                    return false;
                }
                $scope.authVerifyCode.errorContent = '';
                return true;
            },
            verifycodeErrorInfo: '',
        };

        // 图形验证码弹窗
        $scope.graphicVerifyCodeModal = {
            isShow: false,
            verifyCode: '',
            verifyCodeSrc: '',
            verifyCodeIndex: 3,
            verifyStatus: '', // 'success' | 'fail',
            confirmCallback: null,
            getVerifyCode() {
                this.verifyCode = '';
                this.verifyStatus = '';
                const index = $scope.graphicVerifyCodeModal.verifyCodeIndex;
                return "/authui/verifycode?index=" + index + "&alt=" + Math.random();
            },
            onValidated: function () {

            },
            init() {
                $scope.graphicVerifyCodeModal.verifyCodeSrc = this.getVerifyCode();
                this.verifyStatus = '';
                this.verifyCode = '';
            },
            show(callback) {
                this.init();
                this.isShow = true;
                this.confirmCallback = callback;
                $scope.$evalAsync();
            },
            destroy() {
                this.isShow = false;
            },
            verify() {
                iamHttpService.post({
                    url: "/authui/preValidVerifycode",
                    params: {
                        index: this.verifyCodeIndex,
                        verifycode: this.verifyCode,
                    }
                }).then((data) => {
                    if (data === 'success') {
                        this.verifyStatus = 'success';
                    } else {
                        this.init();
                    }
                    $scope.$evalAsync();
                }, 
                    (err) => {
                        iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fpwdPopupMsg');
                    }
                )
            },
            onVerifyCodeChange() {
                this.verifyStatus = '';
                if (this.verifyCode.length === 4) {
                    this.verify();
                } else {
                    this.verifyStatus = 'fail';
                }
            },
            onConfirm() {
                if (this.verifyStatus !== 'success') {
                    $('#fpwd-graphics-input').focus();
                    return;
                }
                if (this.confirmCallback) {
                    this.confirmCallback(this.verifyCode);
                }
                this.destroy();
            },
            onCancel() {
                this.destroy();
            }
        }


        // 密码输入框
        $scope.passwordInput = {
            id: 'newPasswdId',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.newPasswdPH.h5') : i18n('fpwd.newPasswdPH'),
            pwdVisible: false,
            maxLength: _securityPolicy.passwordpolicy.password_maxlen,
            isCorrect: true, //是否符合密码要求
            isWeakPassword: false,
            lowPasswords: [],
            tipId: 'passwordTipId',
            tipShow: false,
            h5TipId: 'h5PasswordTipId',
            style: {
                height: $scope.model.inputHeight,
            },
            change: function () {
                if ($scope.passwordInput.lowPasswords.indexOf($scope.passwordInput.value) > -1) {
                    $scope.passwordInput.isWeakPassword = true;
                } else {
                    $scope.passwordInput.isWeakPassword = false;
                }
                $scope.model.fpwdErrorMsg = '';
                $scope.confirmPasswordInput.value = '';
                showTip($scope);
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_' + $scope.passwordInput.id, '***');
                showTip($scope);
                $scope.passwordInput.tipShow = false;
                $scope.passwordInput.isWeakPassword = false;
                if ($scope.passwordInput.isCorrect) {
                    passwdAsynCheck($scope);
                }
            },
            focus: function () {
                $scope.passwordInput.tipShow = true;
            },
            pwdVisibleFunc: function () {
                $scope.passwordInput.pwdVisible = !$scope.passwordInput.pwdVisible;
                var type = $scope.passwordInput.pwdVisible ? 'text' : 'password';
                $('#' + $scope.passwordInput.id).attr('type', type);
            },
        };

        // 确认密码输入框
        $scope.confirmPasswordInput = {
            id: 'confirmPasswdId',
            value: '',
            ph: $scope.model.isMobile ? i18n('fpwd.confirmPasswdPH.h5') : i18n('fpwd.confirmPasswdPH'),
            pwdVisible: false,
            tipId: 'confirmPasswordTipId',
            tipContent: '',
            tipShow: false,
            style: {
                height: $scope.model.inputHeight,
            },
            change: function () {
                if (!$scope.confirmPasswordInput.value || $scope.confirmPasswordInput.value.length === 0) {
                    $scope.confirmPasswordInput.tipContent = i18n('blankTxt');
                } else if ($scope.confirmPasswordInput.value !== $scope.passwordInput.value) {
                    $scope.confirmPasswordInput.tipContent = i18n('passwordEqual');
                } else {
                    $scope.confirmPasswordInput.tipContent = '';
                }
            },
            blur: function () {
                send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_re_***', '***')
                $scope.confirmPasswordInput.tipShow = false;
            },
            focus: function () {
                $scope.confirmPasswordInput.tipShow = true;
            },
            pwdVisibleFunc: function () {
                $scope.confirmPasswordInput.pwdVisible = !$scope.confirmPasswordInput.pwdVisible;
                var type = $scope.confirmPasswordInput.pwdVisible ? 'text' : 'password';
                $('#' + $scope.confirmPasswordInput.id).attr('type', type);
            },
        };

        $scope.step4Model = {
            resultImg: require('custom/images/success-big.png'),
            loginCountdownTxt: '',
        }

        // 回到登录页面
        $scope.redirect2Login = function () {
            $state.go('login');
        }

        //第一步确认按钮 
        $scope.step1NextHandler = function () {
            if ($scope.model.isCompany) {
                send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_nextStep1', 'operation_iam_iamUserFpwd_step2');
            }
            // 校验是否能下一步
            if (($scope.personalAccountInput.value === '' || $scope.IAMVerifyCode.checkCode === '') && ($scope.phoneInput.phoneValue === '' || $scope.IAMVerifyCode.checkCode === '') && ($scope.IAMAccountInput.value === '' || $scope.IAMUsernameInput.value === '' || $scope.IAMVerifyCode.checkCode === '')) {
                return;
            }
            if ($scope.IAMVerifyCode.checkCode.length < 4) {
                $scope.IAMVerifyCode.getVerifyCode();
                iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEnterpriseVerificationCode'), '', 'fpwdPopupMsg');
                return;
            }
            // 手机找回场景下 需要校验手机号是否有错误
            if (!$scope.model.isCompany && $scope.model.findMethod === 'phone') {
                var phoneInputObj = $('#' + $scope.phoneInput.id);
                if (!phoneValidator($scope)) {
                    phoneInputObj.focus();
                    return;
                }
            }

            // 通过帐号名或者邮箱查询用户绑定的手机或者邮箱 
            getUserAuthMethod($scope);
        };
        //第二步确认按钮 
        $scope.step2NextHandler = function () {
            send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_nextStep2', '');
            // 校验是否能下一步
            if ($scope.authVerifyCode.value === '') {
                return;
            }

            if (!$scope.model.canNextStep) {
                return;
            }
            $scope.model.canNextStep = false;
            // 身份验证
            checkAuthVerifyCode($scope);
        }
        //第三步确认按钮
        $scope.step3NextHandler = function () {
            send2CloudBISafe('button', 'click', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_nextStep3', '');
            // 校验是否能下一步
            if (!$scope.passwordInput.value || !$scope.passwordInput.isCorrect) {
                $('#' + $scope.passwordInput.id).focus();
                return;
            }
            if (!$scope.confirmPasswordInput.value || $scope.confirmPasswordInput.tipContent) {
                $('#' + $scope.confirmPasswordInput.id).focus();
                return;
            }
            // 修改密码提交
            modifyPwd($scope, $state, $interval);
        }

        $scope.initTipPosition = initTipPosition;

        function preValidCallback() {
            $scope.IAMVerifyCode.checkCode = '';
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if (verifyCodeImg) {
                verifyCodeImg.src = '/authui/verifycode?index=4&alt=' + Math.random();
            }
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        // 获取国家码
        getCountryCode($scope);
        initIAMInput($scope);

        // 监听窗口大小修改isMobile变量
        window.onresize = function () {
            $scope.model.isMobile = window.outerWidth > 500 ? false : true;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            setTimeout(function () {
                if (!$scope.model.isMobile) {
                    if ($scope.model.currentStep === 1 && !$scope.model.isCompany && $scope.model.findMethod === 'phone') {
                        initTipPosition($scope.phoneInput.phoneInputId, $scope.phoneInput.phoneTipId);
                    } else if ($scope.model.currentStep === 2) {
                        initTipPosition($scope.authVerifyCode.id, $scope.authVerifyCode.tipId);
                    } else if ($scope.model.currentStep === 3) {
                        initTipPosition($scope.passwordInput.id, $scope.passwordInput.tipId, 'right-top');
                        initTipPosition($scope.confirmPasswordInput.id, $scope.confirmPasswordInput.tipId, 'right-top')
                    }
                }
            }, 100);
        }

    };


    function phoneValidator($scope) {
        if (!$scope.phoneInput.phoneValue || $scope.phoneInput.phoneValue.length === 0) {
            $scope.phoneInput.phoneErrorContent = i18n('blankTxt');
            return false;
        }
        var reg = /^1\d{10}$/;
        if (!reg.test($scope.phoneInput.phoneValue)) {
            $scope.phoneInput.phoneErrorContent = i18n('mobileLoginModel.invalidNumber');
            return false;
        }
        $scope.phoneInput.phoneErrorContent = '';
        return true;
    }

    function send2CloudBISafe() {
        try {
            send2CloudBI.apply(null, arguments);
        } catch (e) {
            console.dir(e)
        }
    }

    function getCountryCode($scope) {
        iamHttpService.get({
            url: '/authui/getCountryCode',
            params: {}
        }).then(function (data) {
            data = typeof data === 'object' ? data : $.parseJSON(data);
            var codeList = data['codeArray'];
            var defaultCode = data['defaultCode'];
            if (codeList.length) {
                codeList = codeList.sort(iamUtils.SortArray('label'));
                $scope.phoneInput.countryCodeOptions = codeList;
                codeList.forEach(function (item) {
                    if (item.id === defaultCode) {
                        $scope.phoneInput.defaultOption = item;
                    }
                })
            }
            $scope.$evalAsync();
        }, function () {
            // getCountryCode接口报错 //todo
        })
    }

    function initTipPosition(eleId, tipId, position) {
        setTimeout(function () {
            if (position === 'right-top') {
                var ele = $('#' + eleId);
                var tip = $('#' + tipId);
                var pos = ele.first().offset();
                tip.css('top', pos.top);
                tip.css('left', pos.left + ele.outerWidth() + 14);
            } else if (position === 'bottom-left') {
                var ele = $('#' + eleId);
                var tip = $('#' + tipId);
                var pos = ele.first().offset();
                tip.css('top', pos.top + ele.outerHeight() + 14);
                tip.css('left', pos.left);
            } else{
                var ele = $('#' + eleId);
                var tip = $('#' + tipId);
                var pos = ele.first().offset();
                tip.css('left', pos.left);
                tip.css('top', pos.top - tip.outerHeight() - 34);
            }
        }, 100);
    }

    // 手机号查找获取用户
    function mobileExist($scope) {
        if ($scope.phoneInput.oldPhoneValue == $scope.phoneInput.phoneValue) {
            return;
        }
        if ($scope.phoneInput.phoneValue == '') {
            $scope.mobileUsers.show = false;
            $scope.model.fpwdErrorMsg = '';
            $scope.phoneInput.oldPhoneValue = '';
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            return;
        }
        // 调用接口前先清除已有的下拉框数据
        $scope.mobileUsers.show = false;
        $scope.mobileUsers.selectOptions = [];

        iamHttpService.post({
            url: '/authui/findowner',
            params: {
                type: 'mobile',
                value: $scope.phoneInput.phoneValue,
                source: 'fpwd'
            }
        }).then(function (data) {
            // 记录旧值 防止多次请求
            $scope.phoneInput.oldPhoneValue = $scope.phoneInput.phoneValue;
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                var count = data.count;
                if (count > 1) {
                    // 多帐号
                    $scope.mobileUsers.show = true;
                    $scope.mobileUsers.selectOptions = data.users;
                    $scope.mobileUsers.defaultOption = $scope.mobileUsers.selectOptions[0];
                } else if (count === 1) {
                    // 单帐号
                    $scope.mobileUsers.show = false;
                    $scope.model.fpwdErrorMsg = '';
                    $scope.mobileUsers.defaultOption = data.users[0];
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            } else {
                // 请求返回错误
                if (data.message === 'addrFrequencyHitMax') {
                    $scope.model.fpwdErrorMsg = iamUtils.i18nFormat(i18n('mobileLoginModel.operationTooFrequent'), 5);
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
            }
        }, function () {
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    // 查询用户是否存在 并且获取可用的身份验证方式
    function getUserAuthMethod($scope) {
        var phonePattern = /^1\d{10}$/;
        var emailpattern = $scope.model.emailRegExp;

        var params = {};
        if (!$scope.model.isCompany && $scope.model.findMethod === 'name') {
            // 租户方式 帐号邮箱找回
            params = {
                type: emailpattern.test($scope.personalAccountInput.value) ? 'email' : 'name',
                userType: 'p',
                value: $scope.personalAccountInput.value.trim(),
                verifyCode: $scope.IAMVerifyCode.checkCode
            }
        } else if (!$scope.model.isCompany && $scope.model.findMethod === 'phone') {
            // 租户方式 手机号找回
            params = {
                type: 'id',
                userType: 'p',
                value: $scope.mobileUsers.defaultOption.domain_id,
                verifyCode: $scope.IAMVerifyCode.checkCode
            }
        } else if ($scope.model.isCompany) {
            // 子用户方式
            var type;
            if (emailpattern.test($scope.IAMUsernameInput.value)) {
                type = 'email';
            } else if (phonePattern.test($scope.IAMUsernameInput.value)) {
                type = 'mobile';
            } else {
                type = 'name';
            }
            params = {
                type: type,
                userType: 'e',
                value: $scope.IAMUsernameInput.value.trim(),
                domainName: $scope.IAMAccountInput.value.trim(),
                verifyCode: $scope.IAMVerifyCode.checkCode
            }
        }

        iamHttpService.post({
            url: '/authui/fpwd/userexists',
            params: params
        }).then(function (data) {
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.code == 200) {
                if (data.result.email === '' && data.result.phone === '') {
                    // todo 未绑定邮箱或者手机
                    $scope.model.fpwdErrorMsg = !$scope.model.isCompany ? i18n('fpwd.step2.unbindDesc') : i18n('fpwd.step2.unbindIAMDesc');
                    $scope.IAMVerifyCode.getVerifyCode();
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                    return;
                } else {
                    // 存在绑定有邮箱或者手机
                    $scope.model.fpwdErrorMsg = '';
                    if (data.result.email !== '') {
                        $scope.authMethod.hasEmail = true;
                        $scope.authMethod.emailObj = {
                            authMethodText: iamUtils.i18nFormat(i18n('fpwd.step2.sendEmailCode'), data.result.email),
                            changeAuthMethodText: i18n('fpwd.step2.switchPhoneVerify'),
                            retrieveVerifyCode: false,
                            retrieveVerifyCodeTxt: '',
                        }
                    }
                    if (data.result.phone !== '') {
                        if (data.result.phone.indexOf('-') > 0) {
                            data.result.phone = data.result.phone.replace(/^0*/, '+');
                            data.result.phone = data.result.phone.replace(/-/, ' ');
                        }
                        $scope.authMethod.hasPhone = true;
                        $scope.authMethod.phoneObj = {
                            authMethodText: iamUtils.i18nFormat(i18n('fpwd.step2.sendMobileCode'), data.result.phone),
                            changeAuthMethodText: i18n('fpwd.step2.switchEmailVerify'),
                            retrieveVerifyCode: false,
                            retrieveVerifyCodeTxt: '',
                        }
                    }
                    // 默认选择邮箱
                    if ($scope.authMethod.hasEmail) {
                        $scope.authMethod.selectMethod = 'email';
                        $scope.authMethod.selectObj = $scope.authMethod.emailObj;
                    } else {
                        $scope.authMethod.selectMethod = 'phone';
                        $scope.authMethod.selectObj = $scope.authMethod.phoneObj;
                    }
                    // 获取用户信息
                    $scope.model.userId = data.result.userid;
                    $scope.model.domainId = data.result.domainid;
                    $scope.model.isDomain = data.result.isdomain;
                }
                goToStep($scope, 2);
            } else {
                if (data.code == 500) {
                    if (data.result === 'addrFrequencyHitMax') {
                        $scope.model.fpwdErrorMsg = iamUtils.i18nFormat(i18n('mobileLoginModel.operationTooFrequent'), 15);
                    } else {
                        // 系统繁忙
                        $scope.model.fpwdErrorMsg = i18n('systemException');
                    }
                } else if (data.code == 432) {
                    $scope.model.fpwdErrorMsg = i18n('pageTimeout');
                } else if (data.code === 400 && data.result === 'this domain is another region') {
                    $scope.model.fpwdErrorMsg = i18n('fpwd.ErrorRegionAccount');
                } else if (data.code === 416) {
                    $scope.model.fpwdErrorMsg = i18n('clientIpInvalid.resetPwd');
                } else {
                    if (!$scope.model.isCompany && $scope.model.findMethod === 'phone') {
                        $scope.model.fpwdErrorMsg = i18n('fpwd.EnterCorrectMobile');
                    } else if (!$scope.model.isCompany) {
                        $scope.model.fpwdErrorMsg = i18n('fpwd.EnterCorrectEnterpriseAccount');
                    } else {
                        $scope.model.fpwdErrorMsg = i18n('fpwd.iamFpwdAccountError');
                    }
                }
                $scope.IAMVerifyCode.getVerifyCode();
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    function goToStep($scope, step) {
        $scope.model.currentStep = step;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    // 重新发送验证码倒计时
    function retrieveCountdown($scope, $interval) {
        var selectObj = $scope.authMethod.selectObj;
        selectObj.retrieveVerifyCode = true;
        var second = 60;
        selectObj.retrieveVerifyCodeTxt = iamUtils.i18nFormat(i18n('fpwd.retrieveTxt'), second);
        var timerHandler;
        timerHandler = $interval(function () {
            second--;
            if (second <= 0) {
                $interval.cancel(timerHandler);
                selectObj.retrieveVerifyCode = false;
            } else {
                selectObj.retrieveVerifyCodeTxt = iamUtils.i18nFormat(i18n('fpwd.retrieveTxt'), second);
            }
        }, 1000)
    }

    // 发送验证码
    function sendVerifyCode($scope, verifyCode) {
        var params = {
            type: $scope.authMethod.selectMethod,
            isdomain: $scope.model.isDomain,
            userid: $scope.model.userId,
            domainid: $scope.model.domainId,
            countryCode: '0086', // 该接口国家码参数仅作为默认值，在auth后端从manager取手机号没有国家码的情况下使用
            graphicsVerifyCode: verifyCode
        };

        iamHttpService.post({
            url: '/authui/fpwd/verifyCode',
            params: params
        }).then(function (data) {
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.retcode == 200) {

            } else if (data.retcode == 405) {    // IP被锁
                iamUtils.MESSAGE.ERROR(i18n('fpwd.ipLocked'), '', 'fpwdPopupMsg');
            } else if (data.retcode == 406) {    // 图形验证码输入错误或已失效，请重试
                iamUtils.MESSAGE.ERROR(i18n('GrapVerifyCodeFailed'), '', 'fpwdPopupMsg');
            } else if (data.retcode == 411) {    // 频率过快
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'fpwdPopupMsg');
            } else if (data.retcode == 412) {    // 锁定
                var lockedMsg = i18n('verifyCode.locked');
                if (data.lockDuration && data.lockDuration !== -1) {
                    lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                }
                iamUtils.MESSAGE.ERROR(lockedMsg, '', 'fpwdPopupMsg');
            } else {                            // 验证码发送失败,请重新点击获取
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fpwdPopupMsg');
            }
        }, function () {
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    // 用户选择身份验证方式之后验证码的校验
    function checkAuthVerifyCode($scope) {
        var params = {
            domain_id: $scope.model.domainId,
            user_id: $scope.model.userId,
            autchcode: $scope.authVerifyCode.value,
            type: $scope.authMethod.selectMethod,
            isdomain: $scope.model.isDomain
        }
        iamHttpService.post({
            url: '/authui/fpwd/authcode/validate',
            params: params
        }).then(function (data) {
            $scope.model.canNextStep = true;
            // 清除错误提示
            $scope.model.fpwdErrorMsg = '';
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                // 验证码校验通过
                $scope.model.authToken = data.token;
                getPwdMinLen($scope);
                goToStep($scope, 3);
                var tipId = $scope.model.isMobile ? $scope.passwordInput.h5TipId : $scope.passwordInput.tipId;
                createPwdValidateTip(tipId, utils.i18nFormat(i18n('minMaxLenTxt'), _securityPolicy.passwordpolicy.password_minlen, _securityPolicy.passwordpolicy.password_maxlen),
                    utils.i18nFormat($scope.model.containsChars, _securityPolicy.passwordpolicy.password_char_combination), $scope.model.maxSameChars, i18n('pwdNotUsernameOrInvert'), null, i18n);
            } else {
                $scope.model.authVerifyCodeValue = '';
                if (data.status == '414' || data.status == '400') {
                    $scope.authVerifyCode.verifycodeErrorInfo = i18n('verifyCode.invalid');
                } else if (data.status == '415') {
                    $scope.authVerifyCode.verifycodeErrorInfo = i18n('verifyCode.error');
                } else {
                    $scope.authVerifyCode.verifycodeErrorInfo = i18n('systemException');
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            $scope.model.canNextStep = true;
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    // 触发出密码校验提示框 //todo
    function getPwdMinLen($scope) {
        var promise = iamHttpService.post({
            url: '/authui/fpwd/policy',
            params: {
                domain_id: $scope.model.domainId,
                user_id: $scope.model.userId,
                token: $scope.model.authToken
            },
            mask: true,
            async: false
        });
        promise.then(function (data) {
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            $scope.model.contSameCharLen = data.cont_same_char_len;
            $scope.model.maxSameChars = $scope.model.contSameCharLen != 0 ? utils.i18nFormat(i18n('passwordPolicy.errorMsgOfRptChar'), data.cont_same_char_len) : null;
            $scope.model.pwdMinLen = data.password_minlen;
            _securityPolicy.passwordpolicy.password_minlen = data.password_minlen;
            _securityPolicy.passwordpolicy.password_char_combination  = data.password_char_combination;
            $scope.model.name = data.name;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, function (data) {
            $scope.model.contSameCharLen = 0;
            $scope.model.maxSameChars = null;
            $scope.model.pwdMinLen = _securityPolicy.passwordpolicy.password_minlen;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
    }

    // 根据tipID在对应的tip div中添加密码校验提示
    function createPwdValidateTip(tipId, number, chars, maxSameChars, notEqualName, notContsMobile) {
        const defaultImg = require('custom/images/default.png');
        var tip = `<div class='tip-div'>
                        <div class='tootip-div'>
                            <img id='minLenId' class='tootip-img' src='${defaultImg}'></img>&nbsp;&nbsp;
                            <div>${number}</div>
                        </div>
                        <div class='tootip-div'>
                            <img id='containsCharsId' class='tootip-img' src='${defaultImg}'></img>&nbsp;&nbsp;\
                            <div>${chars}</div>
                        </div>`;
        if (maxSameChars) {
            tip += `<div id='maxSameCharsLabel' class='tootip-div'>\
                        <img id='maxSameCharsId' class='tootip-img' src='${defaultImg}'></img>&nbsp;&nbsp;\
                        <div>${maxSameChars}</div>\
                    </div>`
        }
        if (notEqualName) {
            tip += `<div class='tootip-div'>\
                        <img id='notNameId' class='tootip-img' src='${defaultImg}'></img>&nbsp;&nbsp;\
                        <div>${notEqualName}</div>\
                    </div>`
        }
        if (notContsMobile) {
            tip += `<div class='tootip-div'>\
                        <img id='notContsId' class='tootip-img' src='${defaultImg}'></img>&nbsp;&nbsp;\
                        <div>${notContsMobile}</div>\
                    </div>`
        }
        tip += `<div class='safetyDegreeDiv'>
                    <div class='safetyDegree'>${i18n('safetyDegree')}</div>
                    <div id='strengthLowCircle0' class='strengthLowCircle'></div>
                    <div id='strengthLow' class='passwordStrength' style=''></div>
                    <div id='strengthLowCircle1' class='strengthLowCircle'></div>
                    <div id='strengthMid' class='passwordStrength' style=''></div>
                    <div id='strengthMidCircle' class='strengthLowCircle'></div>
                    <div id='strengthHigh' class='passwordStrength' style=''></div>
                    <div id='strengthHighCircle' class='strengthLowCircle'></div>
                    <div id='strengthflag'></div>
                </div>
            </div>`;
        var tipDom = $(tip);
        $('#' + tipId + ' .iam-ti-tooltip-content:first').append(tipDom);
    }

    // 校验密码并修改密码提示内容
    function showTip($scope) {
        var password = $scope.passwordInput.value;
        var isBlank = password.length == 0;
        var minLenResult = password.length >= _securityPolicy.passwordpolicy.password_minlen && password.length <= 32;
        var containsCharsResult = utils.validatePasswdChar(password, _securityPolicy.passwordpolicy.password_char_combination);
        var maxSameCharsResult = utils.validateCharNum(password, $scope.model.contSameCharLen);//相同字符连续出现的长度不大于contSameCharLen
        var validatePasswdName = utils.validatePasswdNameSHA256(password, $scope.model.name);//是否是用户名或反转用户名
        $scope.passwordInput.isCorrect = !isBlank && minLenResult && containsCharsResult && maxSameCharsResult && validatePasswdName;
        changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope);//修改密码策略项前的图标
        var level = 'low';
        if (!$scope.model.isWeakPassword || !minLenResult) {
            if (password == '') {
                level = '';
            } else {
                level = utils.getPwdStrengthLevel(password);
            }
        }
        setPwdLvlByLvl('strengthLow', 'strengthMid', 'strengthHigh', 'strengthflag', level, i18n);
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function changePwdValidResult(minLenResult, containsCharsResult, maxSameCharsResult, validatePasswdName, isBlank, $scope) {
        change2ResultEach($scope, 'minLenId', minLenResult);
        change2ResultEach($scope, 'containsCharsId', containsCharsResult);
        change2ResultEach($scope, 'maxSameCharsId', maxSameCharsResult);
        change2ResultEach($scope, 'notNameId', validatePasswdName);
        if (isBlank) {
            $('#containsCharsId').attr('src', $scope.model.validTip);
            $('#minLenId').attr('src', $scope.model.validTip);
            $('#maxSameCharsId').attr('src', $scope.model.validTip);
            $('#notNameId').attr('src', $scope.model.validTip);
        }
    }

    function change2ResultEach($scope, id, result) {
        if (result) {
            $('#' + id).attr('src', $scope.model.validSuc);
        } else {
            $('#' + id).attr('src', $scope.model.validFail);
        }
    }

    function setPwdLvlByLvl(lowId, midId, highId, flag, level, i18n) {
        var defaultColor = '#e2e2e2';
        var lowColor = '#ff4c4c';
        var midColor = '#ff6a00';
        var highColor = '#0a9e00';
        var low;
        var lowCircle;
        var mid;
        var midCircle;
        var high;
        var highCircle;
        var flagStr = '';
        switch (level) {
            case 'high':
                low = lowCircle = mid = midCircle = high = highCircle = highColor;
                flagStr = '&nbsp;&nbsp;' + i18n('strengthHigh');
                $('#' + lowId)[0].style.height = $('#' + midId)[0].style.height = $('#' + highId)[0].style.height = '2px';
                break;
            case 'low':
                low = lowCircle = lowColor;
                mid = midCircle = high = highCircle = defaultColor;
                flagStr = '&nbsp;&nbsp;' + i18n('strengthLow');
                $('#' + lowId)[0].style.height = '2px';
                $('#' + midId)[0].style.height = $('#' + highId)[0].style.height = '2px';
                break;
            case 'mid':
                low = lowCircle = mid = midCircle = midColor;
                high = highCircle = defaultColor;
                flagStr = '&nbsp;&nbsp;' + i18n('strengthMid');
                $('#' + lowId)[0].style.height = $('#' + midId)[0].style.height = '2px';
                $('#' + highId)[0].style.height = '2px';
                break;
            default:
                low = lowCircle = mid = midCircle = high = highCircle = defaultColor;
                flagStr = '&nbsp;&nbsp;';
                $('#' + lowId)[0].style.height = $('#' + midId)[0].style.height = $('#' + highId)[0].style.height = '2px';
        }
        if ($('#' + flag).size() != 0) {
            $('#' + flag)[0].innerHTML = flagStr;
        }
        if ($('#' + lowId).size() != 0) {
            $('#' + lowId)[0].style.background = low;
            $('#' + lowId + 'Circle0')[0].style.background = lowCircle;
            $('#' + lowId + 'Circle1')[0].style.background = lowCircle;
            $('#' + midId)[0].style.background = mid;
            $('#' + midId + 'Circle')[0].style.background = midCircle;
            $('#' + highId)[0].style.background = high;
            $('#' + highId + 'Circle')[0].style.background = highCircle;
        }
    }

    // 弱密码校验
    function passwdAsynCheck($scope) {
        iamHttpService.post({
            url: '/authui/passwdAsynCheck',
            params: {
                pvvd: $scope.passwordInput.value,
                isCheckByName: 'false',
                token: (typeof $scope.model.authToken) !== 'undefined' ? $scope.model.authToken : ''
            }
        }).then(function (data) {
            if (data.result === true) {
                $scope.model.fpwdErrorMsg = '';
            } else {
                if (data.error_code === '1000') {
                    $scope.model.fpwdErrorMsg = i18n('invalidInput');
                } else if (data.error_code === '1001') {
                    $scope.model.fpwdErrorMsg = i18n('pwdNotUsernameOrInvert');
                } else if (data.error_code === '1002') {
                    $scope.model.fpwdErrorMsg = i18n('pwdNotContsMobileOrEmail');
                } else if (data.error_code === '1003') {
                    $scope.passwordInput.isWeakPassword = true;
                    $scope.model.fpwdErrorMsg = i18n('pwdWeak');
                    $scope.passwordInput.lowPasswords.push($scope.passwordInput.value);
                } else if (data === 'checkVerifyCode4Forbidden') {
                    $scope.model.fpwdErrorMsg = i18n('freqLocked');
                } else {
                    $scope.model.fpwdErrorMsg = i18n('systemException');
                }
            }
        }, function () {
            $scope.model.fpwdErrorMsg = i18n('systemException');
        });
    }

    // 修改密码提交
    function modifyPwd($scope, $state, $interval) {
        if ($scope.model.isCompany) {
            send2CloudBISafe('input', 'iamUserFpwd', '', 'operation_iam_iamUserFpwd_step3');
        }
        iamHttpService.post({
            url: '/authui/fpwd/reset',
            params: {
                domain_id: $scope.model.domainId,
                user_id: $scope.model.userId,
                token: $scope.model.authToken,
                password: $scope.passwordInput.value,
                level: iamUtils.getPwdStrengthLevel($scope.passwordInput.value),
                type: $scope.authMethod.selectMethod
            }
        }).then(function (data) {
            var data = typeof data === 'object' ? data : $.parseJSON(data);
            if (data.result === 'success') {
                if ($scope.model.isCompany) {
                    send2CloudBISafe('input', 'change', 'fpwd_' + ($scope.model.isCompany ? 'iam' : 'personal') + '_reset', 'operation_iam_iamUserFpwd_success');
                }
                // 重置成功后记录被修改的帐号cookie
                recordCookie($scope);
                goToStep($scope, 4);
                loginCountdown($scope, $state, $interval);
            } else {
                deleteCookie();
                if (data.status == '403') {
                    // 访问太频繁或者token不对
                    $scope.model.fpwdErrorMsg = i18n('systemException');
                } else if (data.status == '400') {
                    // 密码不对
                    $scope.model.fpwdErrorMsg = i18n('pwdWeak');
                } else if (data.status == '401') {
                    // 已关闭自主管理用户属性
                    $scope.model.fpwdErrorMsg = i18n('selfManage.alertTip');
                } else if (data.status == '416') {
                    // acl
                    $scope.model.fpwdErrorMsg = i18n('clientIpInvalid.resetPwd');
                } else if (data.status == '420') {
                    // 子用户被停用
                    $scope.model.fpwdErrorMsg = i18n('userAccountsStopped');
                } else if (data.status == '412') {
                    // 操作频繁
                    $scope.model.fpwdErrorMsg = i18n('operationTooFrequent');
                } else {
                    $scope.model.fpwdErrorMsg = data.msg;
                }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, function () {
            deleteCookie();
            var errorMsg = i18n('systemException');
            iamUtils.MESSAGE.ERROR(errorMsg, '', 'fpwdPopupMsg');
        });
    }

    function recordCookie($scope) {
        deleteCookie();
        cookieOp.addCookie('findPwdEnd', 'ok', cookieOp.DEFAULT_EXPIRES_TIME);
        if (!$scope.model.isCompany) {
            // 个人帐号
            if ($scope.model.findMethod === 'phone') {
                cookieOp.addCookie('loginType', 'mobile', cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('countryCode', $scope.phoneInput.defaultOption.id, cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('mobile', $scope.phoneInput.phoneValue.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            }
            if ($scope.model.findMethod === 'name') {
                cookieOp.addCookie('loginType', 'personal', cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie('personalAccount', $scope.personalAccountInput.value, cookieOp.DEFAULT_EXPIRES_TIME);
            }
        } else {
            // IAM用户
            cookieOp.addCookie('loginType', 'company', cookieOp.DEFAULT_EXPIRES_TIME);
            cookieOp.addCookie('IAMAccount', $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            cookieOp.addCookie('IAMUsername', $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
        }
    }

    function deleteCookie() {
        cookieOp.delCookie('findPwdEnd');
        cookieOp.delCookie('loginType');
        cookieOp.delCookie('countryCode');
        cookieOp.delCookie('mobile');
        cookieOp.delCookie('personalAccount');
        cookieOp.delCookie('IAMAccount');
        cookieOp.delCookie('IAMUsername');
    }

    // 登录倒计时
    function loginCountdown($scope, $state, $interval) {
        var second = 5;
        $scope.step4Model.loginCountdownTxt = iamUtils.i18nFormat(i18n('fpwd.loginCountdownTxt'), second);
        var timerHandler;
        timerHandler = $interval(function () {
            second--;
            // 1.如果在倒计时结束前离开了找回密码页面 则注销掉该执行
            if ($state.current.name !== 'fpwd') {
                $interval.cancel(timerHandler);
            }
            if (second <= 0) {
                $interval.cancel(timerHandler);
                // 2.如果在倒计时结束时还是找回密码页面 则跳转到登录页面
                if ($state.current.name === 'fpwd') {
                    iamUtils.redirect2Login();
                }
            } else {
                $scope.step4Model.loginCountdownTxt = iamUtils.i18nFormat(i18n('fpwd.loginCountdownTxt'), second);
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        }, 1000)
    }

    function getQueryString(param) {
        var reg = '(^|&)' + param + '=([^&]*)(&|$)';
        var r = window.location.href.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    function resetPage($scope) {
        // 清除错误提示
        $scope.model.fpwdErrorMsg = '';

        // 清除已输入内容
        $scope.personalAccountInput.value = '';
        $scope.phoneInput.phoneValue = '';
        $scope.IAMAccountInput.value = '';
        $scope.IAMUsernameInput.value = '';
        $scope.IAMVerifyCode.checkCode = '';
        $('#verifyCodeVaildResult').hide();

        // 去除多帐号下拉选择框
        $scope.mobileUsers.show = false;
        $scope.mobileUsers.showOptions = false;

        // 重新获取图形验证码
        setTimeout(function () {
            $scope.IAMVerifyCode.getVerifyCode();
        }, 200);
    }

    //通过cookie来设置输入框初始值
    function initIAMInput($scope) {
        if($scope.model.isCompany && cookieOp.getCookie('loginType') === 'company'){
            $scope.IAMAccountInput.value = cookieOp.getCookie('IAMAccount');
            $scope.IAMUsernameInput.value = cookieOp.getCookie('IAMUsername');
        }

    }
    CustomerFPwdController = ['$scope', 'securityPolicy', '$compile', '$interval', '$state', CustomerFPwdController];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.fpwd.ctrl', CustomerFPwdController);

    return CustomerFPwdController;
}
);


// WEBPACK FOOTER //
// ./public/hws/js/fpwd/controllers/fpwdController.js